var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "admission-note-container" }, [
    _c(
      "div",
      { staticClass: "document-container" },
      [
        _c("validation-observer", { ref: "interventionPlanDocument" }, [
          _vm.data
            ? _c("div", { staticClass: "row align-items-center" }, [
                _c("div", { staticClass: "col-12 col-md-10" }, [
                  _c("label", { staticClass: "input-display d-block" }, [
                    _vm._v(" Nota de admisión firmada: ")
                  ]),
                  _vm.data
                    ? _c("span", { staticClass: "text-format" }, [
                        _vm._v(_vm._s(_vm.data.fileName))
                      ])
                    : _vm._e()
                ]),
                !_vm.readOnly
                  ? _c(
                      "div",
                      { staticClass: "col-12 col-md-2 text-right" },
                      [
                        _vm.canReplaceAdmissionNote
                          ? _c("action-button", {
                              attrs: {
                                id: "replace-admission-note-button",
                                i: "fas fa-undo text-green",
                                variant: "btn border-green bg-white mr-2"
                              },
                              on: { click: _vm.onReplaceAdmissionNote }
                            })
                          : _vm._e(),
                        _vm.canDownloadAdmissionNote
                          ? _c("action-button", {
                              attrs: {
                                id: "download-admission-note-button",
                                i: "fas fa-file-download text-white",
                                variant: "btn mr-2 bg-green"
                              },
                              on: { click: _vm.downloadFile }
                            })
                          : _vm._e(),
                        _vm.canReplaceAdmissionNote
                          ? _c("input", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: false,
                                  expression: "false"
                                }
                              ],
                              ref: "admissionNoteRef",
                              attrs: {
                                id: "admissionNoteHidden",
                                accept: _vm.allowedFiles,
                                type: "file"
                              },
                              on: {
                                change: function($event) {
                                  return _vm.updateFileChange($event)
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ])
            : _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-6 pt-0" }, [
                  _c("label", { staticClass: "input-display d-block" }, [
                    _vm._v(" Documento: ")
                  ]),
                  _c("span", { staticClass: "text-format" }, [
                    _vm._v("Admisión Firmada")
                  ])
                ]),
                _c(
                  "div",
                  { staticClass: "col-md-6" },
                  [
                    _c("validation-provider", {
                      attrs: { name: "Archivo", rules: "required" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function({ errors }) {
                            return [
                              _c("custom-file-input", {
                                ref: "attachedDocument",
                                attrs: {
                                  accept: _vm.allowedFiles,
                                  "custom-error-msg":
                                    "Favor de anejar el documento.",
                                  "display-style": "normal",
                                  error: errors[0],
                                  label: "Archivo:",
                                  "label-position": "left",
                                  required: ""
                                },
                                model: {
                                  value: _vm.document,
                                  callback: function($$v) {
                                    _vm.document = $$v
                                  },
                                  expression: "document"
                                }
                              })
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-12 mt-3 mt-md-2 d-flex justify-content-end"
                  },
                  [
                    _c("action-button", {
                      attrs: {
                        i: "fa fa-file-plus",
                        text: "Guardar",
                        variant: "success"
                      },
                      on: { click: _vm.saveDocumentHandler }
                    })
                  ],
                  1
                )
              ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }